import * as React from "react";
import { SVGAttributes } from "react";

export const VerificationIcon = React.memo(
  ({
    size = 24,
    color = "#4E5361",
    ...props
  }: SVGAttributes<SVGElement> & {
    size?: number,
  }) => {
    return (
      <svg width={size} height={size} fill="none" {...props}>
        <path
          fill="#fff"
          d="M45.035 12.646l-6.007-2.672-2.674-6.009-6.536.683L24.5.79l-5.321 3.857-6.534-.683L9.973 9.97l-6.009 2.675.683 6.537L.79 24.5l3.857 5.322-.683 6.533 6.006 2.672 2.675 6.009 6.537-.683L24.5 48.21l5.32-3.857 6.534.683 2.672-6.007 6.009-2.674-.683-6.537 3.857-5.318-3.857-5.32.683-6.534zM19.758 33.984l-6.71-6.71 2.236-2.228 4.474 4.465L33.169 16.1l2.237 2.236-15.648 15.648z"
        />
        <path
          fill="#FFBAB0"
          d="M48.85 24.036l-3.68-5.076.651-6.235a.79.79 0 00-.465-.804L39.63 9.37l-2.55-5.727a.795.795 0 00-.804-.466l-6.235.652L24.964.15a.79.79 0 00-.928 0L18.96 3.83l-6.236-.652a.801.801 0 00-.804.465L9.37 9.37l-5.728 2.55a.79.79 0 00-.465.803l.652 6.236-3.68 5.076a.79.79 0 000 .928l3.68 5.076-.652 6.235a.79.79 0 00.465.805l5.728 2.549 2.549 5.728c.14.31.464.498.804.465l6.236-.652 5.076 3.68c.277.2.651.2.928 0l5.076-3.68 6.235.652a.795.795 0 00.805-.464l2.549-5.728 5.727-2.55a.79.79 0 00.465-.804l-.652-6.236 3.68-5.075a.79.79 0 000-.929zm-5.138 5.321a.788.788 0 00-.146.546l.623 5.965-5.481 2.44a.784.784 0 00-.402.4l-2.438 5.482-5.966-.624a.788.788 0 00-.546.147l-4.856 3.52-4.857-3.52a.781.781 0 00-.463-.15c-.028 0-.056 0-.08.003l-5.967.624-2.438-5.481a.79.79 0 00-.401-.402L4.81 35.868l.623-5.965a.792.792 0 00-.146-.546L1.767 24.5l3.52-4.857a.792.792 0 00.146-.546L4.81 13.13l5.48-2.44a.783.783 0 00.402-.4l2.438-5.48 5.967.623a.797.797 0 00.546-.147l4.857-3.52 4.857 3.52a.794.794 0 00.545.147l5.967-.624 2.438 5.48a.79.79 0 00.402.402l5.48 2.44-.622 5.965a.789.789 0 00.146.546l3.52 4.857-3.52 4.857z"
        />
        <path
          fill="#9B53C8"
          d="M33.728 15.541a.79.79 0 00-1.117 0L19.758 28.394l-3.914-3.907a.79.79 0 00-1.116 0l-2.24 2.226a.79.79 0 000 1.12l6.71 6.71a.79.79 0 001.117 0l15.648-15.649a.79.79 0 000-1.117l-2.235-2.236zm-13.97 17.326l-5.591-5.592 1.117-1.115 3.916 3.908a.79.79 0 001.117 0l12.852-12.851 1.12 1.12-14.53 14.53z"
        />
      </svg>
    );
  }
);
